import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import { useLoadProgress } from '../hooks/useLoadProgress'
import { useSurveyParams } from '../context/SurveyParamsContext'
import 'survey-core/i18n/traditional-chinese'
import {
  convertVisibleIf,
  convertQuestionMappings,
} from '../utils/convertVisibleIf'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 暫存需加
  const [isReady, setIsReady] = useState(false)
  const userIdRef = useRef(null)
  // web_auth_type=1/2 也要啟動暫存
  const [webAuthType, setWebAuthType] = useState(0)
  // 名單式調查參數
  const { sfdSamplerId, sfdPId } = useSurveyParams()

  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  const visibleIfConditionsInit = convertVisibleIf({
    // Q2.1 出生階段：q2 選第 N 個縣市 → 顯示該縣市鄉鎮市區題 q3~q24
    q3: '{q2} = 1',
    q4: '{q2} = 2',
    q5: '{q2} = 3',
    q6: '{q2} = 4',
    q7: '{q2} = 5',
    q8: '{q2} = 6',
    q9: '{q2} = 7',
    q10: '{q2} = 8',
    q11: '{q2} = 9',
    q12: '{q2} = 10',
    q13: '{q2} = 11',
    q14: '{q2} = 12',
    q15: '{q2} = 13',
    q16: '{q2} = 14',
    q17: '{q2} = 15',
    q18: '{q2} = 16',
    q19: '{q2} = 17',
    q20: '{q2} = 18',
    q21: '{q2} = 19',
    q22: '{q2} = 20',
    q23: '{q2} = 21',
    q24: '{q2} = 22',
    // Q2.2 0-6歲(幼兒期)：q29 選第 N 個縣市 → 顯示該縣市鄉鎮市區題 q30~q51
    q30: '{q29} = 1',
    q31: '{q29} = 2',
    q32: '{q29} = 3',
    q33: '{q29} = 4',
    q34: '{q29} = 5',
    q35: '{q29} = 6',
    q36: '{q29} = 7',
    q37: '{q29} = 8',
    q38: '{q29} = 9',
    q39: '{q29} = 10',
    q40: '{q29} = 11',
    q41: '{q29} = 12',
    q42: '{q29} = 13',
    q43: '{q29} = 14',
    q44: '{q29} = 15',
    q45: '{q29} = 16',
    q46: '{q29} = 17',
    q47: '{q29} = 18',
    q48: '{q29} = 19',
    q49: '{q29} = 20',
    q50: '{q29} = 21',
    q51: '{q29} = 22',
    // q29 選 23「98-居住地區與前一階段相同」→ 不顯示 B/C-1/C-2/D
    q52: '{q29} <> 23',
    q53: '{q29} <> 23',
    q54: '{q29} <> 23',
    q55: '{q29} <> 23',
    // Q2.3 7-15歲居住最久：q56 選第 N 個縣市 → 顯示該縣市鄉鎮市區題 q57~q78
    q57: '{q56} = 1',
    q58: '{q56} = 2',
    q59: '{q56} = 3',
    q60: '{q56} = 4',
    q61: '{q56} = 5',
    q62: '{q56} = 6',
    q63: '{q56} = 7',
    q64: '{q56} = 8',
    q65: '{q56} = 9',
    q66: '{q56} = 10',
    q67: '{q56} = 11',
    q68: '{q56} = 12',
    q69: '{q56} = 13',
    q70: '{q56} = 14',
    q71: '{q56} = 15',
    q72: '{q56} = 16',
    q73: '{q56} = 17',
    q74: '{q56} = 18',
    q75: '{q56} = 19',
    q76: '{q56} = 20',
    q77: '{q56} = 21',
    q78: '{q56} = 22',
    // q56 選 23「98-居住地區與前一階段相同」→ 不顯示 B/C-1/C-2/D
    q79: '{q56} <> 23',
    q80: '{q56} <> 23',
    q81: '{q56} <> 23',
    q82: '{q56} <> 23',
    // Q2.4 15歲以後居住最久：q83 選第 N 個縣市 → 顯示該縣市鄉鎮市區題 q84~q105
    q84: '{q83} = 1',
    q85: '{q83} = 2',
    q86: '{q83} = 3',
    q87: '{q83} = 4',
    q88: '{q83} = 5',
    q89: '{q83} = 6',
    q90: '{q83} = 7',
    q91: '{q83} = 8',
    q92: '{q83} = 9',
    q93: '{q83} = 10',
    q94: '{q83} = 11',
    q95: '{q83} = 12',
    q96: '{q83} = 13',
    q97: '{q83} = 14',
    q98: '{q83} = 15',
    q99: '{q83} = 16',
    q100: '{q83} = 17',
    q101: '{q83} = 18',
    q102: '{q83} = 19',
    q103: '{q83} = 20',
    q104: '{q83} = 21',
    q105: '{q83} = 22',
    // q83 選 23「98-居住地區與前一階段相同」→ 不顯示 B/C-1/C-2/D
    q106: '{q83} <> 23',
    q107: '{q83} <> 23',
    q108: '{q83} <> 23',
    q109: '{q83} <> 23',
    // 【電訪】題：預載電訪資料，一律隱藏（暫時拿掉，之後再加回）
    // q110: 'false',
    // q112: 'false',
    // q114: 'false',
    // q136: 'false',
    // q138: 'false',
    // q140: 'false',
    // q141: 'false',
    // q143: 'false',
    // q144: 'false',
    // A8(q110) 選 1臺灣客家人/2大陸客家人/6海外華僑客家人 → Q3
    q111: '{q110} = 1 or {q110} = 2 or {q110} = 6',
    // A7(q112，複選) 勾 1/2/6 → Q4
    q113: '{q112} anyof [1, 2, 6]',
    // A30(q114) 1是客家人 → Q5.1；2不是客家人 → Q5.2
    q115: '{q114} = 1',
    q116: '{q114} = 2',
    // Q7.2(q120) 選 5「(90)沒有其次」→ 不顯示 Q7.3
    q121: '{q120} <> 5',
    // Q8(q122) 選 3「沒變」→ 不顯示 Q8.1
    q123: '{q122} <> 3',
    // Q13(q129) 選 6「其他」→ Q14
    q130: '{q129} = 6',
    // A22/A23/A17/A32 選 4很少講/5幾乎不講 → 追問沒講客語原因
    q137: '{q136} = 4 or {q136} = 5',
    q139: '{q138} = 4 or {q138} = 5',
    q142: '{q141} = 4 or {q141} = 5',
    q145: '{q144} = 4 or {q144} = 5',
    // Q23(q146) 選 2「沒有(不會)」→ Q24
    q147: '{q146} = 2',
    // Q25(q148) 選 6「(66)都不選」→ 不顯示 Q25.1
    q149: '{q148} <> 6',
    // Q32(q159) 選 10軍人/11學生/12家庭管理/13退休/14無業 → 不顯示 Q33
    q160: '{q159} <> 10 and {q159} <> 11 and {q159} <> 12 and {q159} <> 13 and {q159} <> 14',
    // Z7(q169) 選 3「不同」→ Z7-1
    q170: '{q169} = 3',
  })
  const notRequired = null
  const mappedRateChoice = null
  const pageBreakQuestions = null
  const triggersConditionsInit = null
  const questionMappings = convertQuestionMappings({})

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    setWebAuthType,
    sfdSamplerId,
    sfdPId,
  })

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  useLoadProgress({
    surveyModel: surveyModel,
    convertedSurvey: myAgreeJson,
    isReady,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
    webAuthType,
    sfdSamplerId,
  })

  useEffect(() => {
    if (agreeSurvey) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [agreeSurvey])

  useEffect(() => {
    if (surveyModel) {
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100)
    }
  }, [surveyModel])

  function helpFunction(survey, options) {}

  const endSurveyMsg = (survey) => {
    setCompletionMessage(
      `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
    )
  }

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    userIdRef,
    enableProgressSaving: webAuthType > 0 || !!sfdSamplerId,
    webAuthType,
    sfdSamplerId,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
